import React from 'react';
import { Link } from 'react-router';
import { Button, Container, Icon } from 'semantic-ui-react';

import BrowserTitle from '../../utils/BrowserTitle';
import NotFound from '../NotFound';
import { getTrainingVideo, trainingVideos } from './trainingContent';

import './assets/style.css';

const VideoLink = ({ direction, video }) => {
  if (!video) return <span />;

  const isPrevious = direction === 'previous';

  return (
    <Button
      as={Link}
      to={`/training/video/${video.id}`}
      className={`training-sequence-link training-sequence-${direction}`}
      aria-label={`${isPrevious ? 'Previous video' : 'Next video'}: ${
        video.title
      }`}
    >
      {isPrevious && <Icon name="arrow left" aria-hidden="true" />}
      <span>
        <span className="training-sequence-label">
          {isPrevious ? 'Previous video' : 'Next video'}
        </span>
        <span className="training-sequence-title">
          {video.number}: {video.title}
        </span>
      </span>
      {!isPrevious && <Icon name="arrow right" aria-hidden="true" />}
    </Button>
  );
};

const TrainingVideo = ({ params }) => {
  const video = getTrainingVideo(params.videoId);

  if (!video) return <NotFound />;

  const currentIndex = trainingVideos.indexOf(video);
  const previousVideo = trainingVideos[currentIndex - 1];
  const nextVideo = trainingVideos[currentIndex + 1];
  const isFinalVideo = currentIndex === trainingVideos.length - 1;

  return (
    <div className="training-page training-video-page">
      <BrowserTitle title={`${video.number}: ${video.title}`} />

      <nav className="training-subnav" aria-label="Training navigation">
        <Container>
          <Link to="/profile#training">
            <Icon name="home" aria-hidden="true" /> Training Home
          </Link>
          <Link to="/profile#training-course-videos">
            <Icon name="list" aria-hidden="true" /> All Videos
          </Link>
        </Container>
      </nav>

      <main id="training-video-content">
        <Container className="training-video-container">
          <p className="training-eyebrow">
            {video.number} &middot; {currentIndex + 1} of{' '}
            {trainingVideos.length}
          </p>
          <div className="training-video-heading">
            <div>
              <h1>{video.title}</h1>
              <p>{video.description}</p>
            </div>
            <span className="training-runtime-badge">
              <Icon name="clock outline" aria-hidden="true" />
              <span className="sr-only">Run time: </span>
              {video.runtime}
            </span>
          </div>

          <div className="training-player-frame">
            <video
              key={video.id}
              className="training-player"
              aria-label={`${video.number}: ${video.title}`}
              controls
              preload="metadata"
              controlsList="nodownload"
            >
              <source src={video.video} type="video/mp4" />
              <track
                default
                kind="captions"
                src={video.captions}
                srcLang="en-US"
                label="English"
              />
              Your browser does not support the video player. You can{' '}
              <a href={video.video}>open the MP4 video directly</a>.
            </video>
          </div>

          <nav className="training-sequence-nav" aria-label="Course sequence">
            <VideoLink direction="previous" video={previousVideo} />
            <VideoLink direction="next" video={nextVideo} />
          </nav>

          {isFinalVideo && (
            <section
              className="training-completion"
              aria-labelledby="course-completion-title"
            >
              <span className="training-completion-icon" aria-hidden="true">
                <Icon name="check" />
              </span>
              <div>
                <p className="training-eyebrow">Course completion</p>
                <h2 id="course-completion-title">
                  You have completed IT-AMS New User Training.
                </h2>
                <p>
                  Print this completion certificate for your records. Return to
                  All Videos at any time to review a topic again or use the
                  course as a refresher.
                </p>
                <div className="training-completion-actions">
                  {/* <Button
                    as="a"
                    href="/training/certificate/FY27 IT-AMS New User Training Certificate of Completion.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    primary
                  >
                    <Icon name="print" aria-hidden="true" />
                    Open completion certificate
                    <span className="sr-only"> (opens in a new window)</span>
                  </Button> */}
                  <Button as={Link} to="/profile#training-course-videos" basic>
                    <Icon name="list" aria-hidden="true" /> Return to All Videos
                  </Button>
                </div>
              </div>
            </section>
          )}
        </Container>
      </main>
    </div>
  );
};

export default TrainingVideo;
